// AdminEnrollmentRow — one read-only <tr> in EnrollmentsPage. Payment status is shown, never edited here:
// it changes only when a payment is confirmed (Payments page → Mark paid, with proof).
import PaymentStatusBadge from "../shared/PaymentStatusBadge.js";
import type { AdminEnrollment } from "../../lib/adminEnrollmentTypes.js";
import { formatDate } from "../../lib/formatDateTime.js";

interface AdminEnrollmentRowProps {
  enrollment: AdminEnrollment;
}

export default function AdminEnrollmentRow({ enrollment }: AdminEnrollmentRowProps) {
  return (
    <tr>
      <td className="px-4 py-3">
        <p className="font-medium text-dm-navy">{enrollment.studentName}</p>
        <p className="text-xs text-dm-slate">{enrollment.studentCode}</p>
      </td>
      <td className="px-4 py-3">
        <p className="text-dm-navy">{enrollment.courseTitle}</p>
        <p className="text-xs text-dm-slate">{enrollment.courseCode}</p>
      </td>
      <td className="px-4 py-3">
        <PaymentStatusBadge status={enrollment.paymentStatus} />
      </td>
      <td className="px-4 py-3">{formatDate(enrollment.enrolledAt)}</td>
      <td className="px-4 py-3">{enrollment.completedAt ? formatDate(enrollment.completedAt) : "—"}</td>
    </tr>
  );
}
